/**
 * TOXIC TENDENCIES — tt-cart-drawer.js
 * assets/tt-cart-drawer.js
 */

(function () {
  'use strict';

  const EMPTY_CTA_URL  = '/#drop-01';
  const EMPTY_CTA_TEXT = 'SHOP DROP 01';

  let drawer, overlay, closeBtn, cartBody, footer;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function setCount(n) {
    document.querySelectorAll('#tt-cart-count, .tt-cart-count').forEach(function(el) {
      el.textContent = n;
    });
    document.querySelectorAll('.header__cart-badge').forEach(function(el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function openDrawer() {
    drawer.style.setProperty('transform', 'translateX(0px)', 'important');
    overlay.style.setProperty('opacity', '1', 'important');
    overlay.style.setProperty('pointer-events', 'all', 'important');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.style.setProperty('overflow', 'hidden', 'important');
    fetchCart();
  }

  function closeDrawer() {
    drawer.style.setProperty('transform', 'translateX(100%)', 'important');
    overlay.style.setProperty('opacity', '0', 'important');
    overlay.style.setProperty('pointer-events', 'none', 'important');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.style.removeProperty('overflow');
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function(err) { console.error('[TT Cart] fetch error:', err); });
  }

  function refreshCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { setCount(cart.item_count); })
      .catch(function() {});
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    document.getElementById('tt-cart-count').textContent = cart.item_count;

    if (cart.item_count === 0) {
      renderEmpty();
      return;
    }

    document.getElementById('tt-cart-total').textContent = formatMoney(cart.total_price);
    footer.style.setProperty('display', 'block', 'important');
    cartBody.innerHTML = cart.items.map(renderItem).join('');

    cartBody.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', handleQtyMinus);
    });
    cartBody.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', handleQtyPlus);
    });
    cartBody.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', handleRemove);
    });
  }

  function getLineItemImage(item) {
    if (item.featured_image && item.featured_image.url) {
      return item.featured_image.url;
    }
    return item.image || '';
  }

  function getVisibleVariantValues(item) {
    if (!Array.isArray(item.options_with_values)) return [];

    return item.options_with_values
      .filter(function(option) {
        return String(option.name || '').toLowerCase() !== 'category';
      })
      .map(function(option) {
        return option.value;
      })
      .filter(Boolean);
  }

  function renderItem(item) {
    var imgSrc = getLineItemImage(item);
    var visibleVariantValues = getVisibleVariantValues(item);

    var metaHtml = '';
    if (visibleVariantValues.length) {
      metaHtml = '<p style="font-size:11px;font-weight:500;color:#0a0a0a;margin:4px 0 0;line-height:1.7;letter-spacing:0.04em;">'
        + visibleVariantValues.join('<br>')
        + '</p>';
    }

    return '<div data-key="' + item.key + '" style="display:flex;align-items:flex-start;gap:20px;padding:28px 28px;border-bottom:1px solid rgba(0,0,0,0.07);">'
      + '<div style="flex-shrink:0;width:110px;height:132px;overflow:hidden;background:#f5f5f5;">'
      + (imgSrc
          ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:cover;object-position:center top;display:block;" loading="lazy">'
          : '<div style="width:110px;height:132px;background:#f0f0f0;"></div>')
      + '</div>'
      + '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:6px;padding-top:2px;">'
      + '<p style="font-size:12px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#0a0a0a;margin:0;line-height:1.45;">' + item.product_title + '</p>'
      + '<p style="font-size:15px;font-weight:700;color:#0a0a0a;margin:0;letter-spacing:0.02em;">' + formatMoney(item.final_line_price) + '</p>'
      + metaHtml
      + '</div>'
      + '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;gap:12px;flex-shrink:0;height:132px;">'
      + '<div style="display:flex;align-items:center;border:1px solid rgba(0,0,0,0.18);">'
      + '<button data-qty-minus data-key="' + item.key + '" style="display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;width:34px;height:34px;font-size:18px;font-weight:300;color:#0a0a0a;line-height:1;">\u2212</button>'
      + '<span style="width:32px;text-align:center;font-size:13px;font-weight:600;color:#0a0a0a;border-left:1px solid rgba(0,0,0,0.18);border-right:1px solid rgba(0,0,0,0.18);line-height:34px;display:block;font-family:Manrope,sans-serif;">' + item.quantity + '</span>'
      + '<button data-qty-plus data-key="' + item.key + '" style="display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;width:34px;height:34px;font-size:18px;font-weight:300;color:#0a0a0a;line-height:1;">+</button>'
      + '</div>'
      + '<button data-remove data-key="' + item.key + '" aria-label="Remove item" style="background:none;border:none;cursor:pointer;color:rgba(0,0,0,0.35);padding:4px;display:flex;align-items:center;justify-content:center;">'
      + '<svg viewBox="0 0 16 18" fill="none" width="17" height="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"><path d="M1 4h14M6 4V2h4v2M2 4l1 12h10L14 4"/><path d="M6 8v6M10 8v6"/></svg>'
      + '</button>'
      + '</div>'
      + '</div>';
  }

  function renderEmpty() {
    footer.style.setProperty('display', 'none', 'important');
    cartBody.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:60px 28px;text-align:center;gap:32px;">'
      + '<p style="font-size:11px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:#0a0a0a;margin:0;">YOUR CART IS EMPTY.</p>'
      + '<a href="' + EMPTY_CTA_URL + '" id="tt-cart-shop-link" style="display:inline-block;font-size:11px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;text-decoration:none;color:#ffffff;background:#0a0a0a;padding:14px 32px;border:1px solid #0a0a0a;font-family:Manrope,sans-serif;">' + EMPTY_CTA_TEXT + '</a>'
      + '</div>';
    var shopLink = document.getElementById('tt-cart-shop-link');
    if (shopLink) shopLink.addEventListener('click', closeDrawer);
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function(err) { console.error('[TT Cart] update error:', err); });
  }

  function handleQtyMinus(e) {
    var key = e.currentTarget.dataset.key;
    var row = cartBody.querySelector('[data-key="' + key + '"]');
    var qtyEl = row && row.querySelector('span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    updateItem(key, Math.max(0, current - 1));
  }

  function handleQtyPlus(e) {
    var key = e.currentTarget.dataset.key;
    var row = cartBody.querySelector('[data-key="' + key + '"]');
    var qtyEl = row && row.querySelector('span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    updateItem(key, current + 1);
  }

  function handleRemove(e) {
    updateItem(e.currentTarget.dataset.key, 0);
  }

  // Cart icon toggle
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }
  });

  // Standard form submit (product page ATC)
  function bindAtcForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      if (form._ttAtcBound) return;
      form._ttAtcBound = true;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        formData.delete('sections');
        formData.delete('sections_url');
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn._origText = submitBtn.textContent;
          submitBtn.textContent = 'ADDING...';
        }
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function(r) { if (!r.ok) throw new Error('failed'); return r.json(); })
          .then(function() { openDrawer(); })
          .catch(function(err) { console.error('[TT Cart] add error:', err); })
          .finally(function() {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn._origText || 'ADD TO CART';
            }
          });
      });
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  function init() {
    // Clean up any previous instances
    ['tt-cart-root', 'tt-cart-drawer', 'tt-cart-overlay'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.parentNode.removeChild(el);
    });

    // Overlay
    overlay = document.createElement('div');
    overlay.id = 'tt-cart-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background:rgba(0,0,0,0.55);z-index:99998;opacity:0;pointer-events:none;transition:opacity 0.38s ease;';

    // Drawer shell
    drawer = document.createElement('div');
    drawer.id = 'tt-cart-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.style.cssText = 'position:fixed;top:0;right:0;left:auto;bottom:0;width:500px;max-width:100vw;height:100%;background:#ffffff;z-index:99999;display:flex;flex-direction:column;transform:translateX(100%);transition:transform 0.38s cubic-bezier(0.4,0,0.2,1);font-family:Manrope,sans-serif;-webkit-font-smoothing:antialiased;box-shadow:-4px 0 40px rgba(0,0,0,0.12);';

    // Header
    var header = document.createElement('div');
    header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:0 28px;height:72px;flex-shrink:0;border-bottom:1px solid rgba(0,0,0,0.10);';

    var title = document.createElement('span');
    title.style.cssText = 'font-family:"Bebas Neue",sans-serif;font-size:clamp(24px,3vw,32px);font-weight:400;letter-spacing:0.10em;text-transform:uppercase;color:#0a0a0a;line-height:1;';
    title.innerHTML = 'YOUR CART (<span id="tt-cart-count">0</span>)';

    closeBtn = document.createElement('button');
    closeBtn.id = 'tt-cart-close';
    closeBtn.setAttribute('aria-label', 'Close cart');
    closeBtn.style.cssText = 'background:none;border:none;cursor:pointer;color:#0a0a0a;padding:8px;margin-right:-8px;display:flex;align-items:center;justify-content:center;';
    closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 18 18" fill="none"><line x1="1" y1="1" x2="17" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="square"/><line x1="17" y1="1" x2="1" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>';

    header.appendChild(title);
    header.appendChild(closeBtn);

    // Body
    cartBody = document.createElement('div');
    cartBody.id = 'tt-cart-body';
    cartBody.style.cssText = 'flex:1;overflow-y:auto;overflow-x:hidden;';

    // Footer
    footer = document.createElement('div');
    footer.id = 'tt-cart-footer';
    footer.style.cssText = 'flex-shrink:0;padding:22px 28px 32px;border-top:1px solid rgba(0,0,0,0.10);background:#ffffff;';
    footer.innerHTML = '<div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:20px;">'
      + '<span style="font-family:Manrope,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:#0a0a0a;">TOTAL:</span>'
      + '<span id="tt-cart-total" style="font-size:18px;font-weight:700;color:#0a0a0a;font-family:Manrope,sans-serif;letter-spacing:0.02em;">$0.00</span>'
      + '</div>'
      + '<a href="/checkout" style="display:block;width:100%;background:#0a0a0a;color:#ffffff;font-family:Manrope,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;text-decoration:none;text-align:center;padding:18px 24px;border:1px solid #0a0a0a;box-sizing:border-box;">CHECKOUT</a>';

    drawer.appendChild(header);
    drawer.appendChild(cartBody);
    drawer.appendChild(footer);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    bindAtcForms();
    new MutationObserver(bindAtcForms).observe(document.body, { childList: true, subtree: true });

    // Initial badge sync
    refreshCount();

    // Expose openDrawer globally so drop-01.liquid and other sections can call it
    window.__ttCartOpen = function() { openDrawer(); };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
